import { cloneDeep } from 'lodash';
const defaultRxManagerFilter = {
  currentPage: 1,
  pageSize: 10,
  order: 'desc',
  orderBy: 'modifiedDate',
  filters: [],
};
const defaultPOFilter = {
  currentPage: 1,
  pageSize: 10,
  order: 'desc',
  orderBy: 'poDate',
  filters: [],
};
const defaultInvoiceFilter = {
  currentPage: 1,
  pageSize: 10,
  orderBy: 'toInvoiceDate',
  order: 'desc',
  filters: [],
};
const defaultInventoryFilter = {
  currentPage: 1,
  pageSize: 10,
  order: 'desc',
  orderBy: 'modifiedDate',
  filters: [],
};
const defaultContractsFilter = {
  currentPage: 1,
  pageSize: 10,
  order: 'desc',
  orderBy: 'effectiveStartDate',
  filters: [],
};
const defaultReportsFilter = {
  currentPage: 1,
  pageSize: 10,
  order: 'desc',
  orderBy: 'createdDate',
  filters: [],
};
const defaultDrugcatalogFilter = {
  currentPage: 1,
  pageSize: 10,
  order: 'desc',
  orderBy: 'createdDate',
  filters: [],
  
}
const defaultConfigurations = {
  currentPage: 1,
  pageSize: 10,
  order: 'desc',
  orderBy: 'createdDate',
  filters: [],
  
}
const defaultStates = {
  purchaseOrder: {
    hasFilterd: false,
    search: cloneDeep(defaultPOFilter),
    thirdPartyAdmin: {},
    orderStatus: null,
    wholesaler: null,
    coveredEntity: null,
    pharmacy: null,
    chainPharmacy : null ,
    searchTerms: {
      thirdPartyAdminID: '',
      coveredEntityID: '',
      pharmacyID: '',
      chainPharmacyID : null ,
      poNumber: '',
      invoicenumber: '',
      startDate: '',
      endDate: '',
      orderStatusID: '',
      wholesalerID: null,
      ceIds: {},
      pharmacyids: {},
      Non340BTenantID : null ,
      associateTypeID : null
    },
  },

  Inventory: {
    hasFilterd: false,
    search: cloneDeep(defaultInventoryFilter),
    thirdPartyAdmin: {},
    orderStatus: null,
    wholesaler: null,
    coveredEntity: null,
    pharmacy: null,
    searchTerms: {
      thirdPartyAdminID: '',
      coveredEntityID: '',
      pharmacyID: '',
      poNumber: '',
      ndc:'',
      invoicenumber: '',
      startDate: '',
      endDate: '',
      orderStatusID: '',
      wholesalerID: '',
      ceIds: {},
      pharmacyids: {}
    },


  },

  Invoice: {
    hasFilterd: false,
    search: cloneDeep(defaultInvoiceFilter),
    thirdPartyAdmin: {},
    orderStatus: null,
    wholesaler: null,
    coveredEntity: null,
    pharmacy: null,
    searchTerms: {
      thirdPartyAdminID: '',
      coveredEntityID: '',
      ceIds: {}

    },
  },
  contracts: {
    hasFilterd: false,
    search: cloneDeep(defaultContractsFilter),
    thirdPartyAdmin: {},
    coveredEntity: null,
    pharmacy: null,
    searchTerms: {
      thirdPartyAdminID: '',
      coveredEntityID: '',
      pharmacyID: '',
      ceIds: {},
      pharmacyids: {}
    },

  },
  reports: {
    hasFilterd: false,
    search: cloneDeep(defaultReportsFilter),
    pharmacies: [],
    coveredEntities: [],
    thirdPartyAdmin: {},
    coveredEntity: null,
    pharmacy: null,
    selectedReportType: {},
    selectedDateRange: {},
    startDate: '',
    endDate: '',
    claimTypeId: 0,
    statusTypeId: 0,

    searchTerms: {
      thirdPartyAdminID: '',
      // coveredEntityID: '',
      // pharmacyIds: '',
      reportType: 1,
      dateRangeID: 0,
      startDate: '',
      endDate: '',
      ceIds: {},
      pharmacyids:{},
      claimTypeId: 0,
      statusTypeId: 0,
    },

  },
  ClaimReports: {
    hasFilterd: false,
    search: cloneDeep(defaultReportsFilter),
    pharmacies: [],
    coveredEntities: [],
    thirdPartyAdmin: {},
    coveredEntity: null,
    pharmacy: null,
    selectedReportType: {},
    selectedDateRange: {},
    startDate: '',
    endDate: '',
    searchTerms: {
      thirdPartyAdminID: '',
      // coveredEntityID: '',
      pharmacyIDs: '',
      reportType: '',
      dateRange: '',
      startDate: '',
      claimTypeId: '',
      statusTypeId: '',
      endDate: '',
    },
  },
  ReplenishedClaimReports: {
    hasFilterd: false,
    search: cloneDeep(defaultReportsFilter),
    pharmacies: [],
    coveredEntities: [],
    thirdPartyAdmin: {},
    coveredEntity: null,
    pharmacy: null,
    selectedReportType: {},
    selectedDateRange: {},
    startDate: '',
    endDate: '',
    searchTerms: {
      thirdPartyAdminID: '',
      // coveredEntityID: '',
      pharmacyIDs: '',
      reportType: '',
      dateRange: '',
      startDate: '',
      endDate: '',
    },
  },
  NonReplenishedClaimReports: {
    hasFilterd: false,
    search: cloneDeep(defaultReportsFilter),
    pharmacies: [],
    coveredEntities: [],
    thirdPartyAdmin: {},
    coveredEntity: null,
    pharmacy: null,
    selectedReportType: {},
    selectedDateRange: {},
    startDate: '',
    endDate: '',
    searchTerms: {
      thirdPartyAdminID: '',
      // coveredEntityID: '',
      pharmacyIDs: '',
      reportType: '',
      dateRange: '',
      startDate: '',
      endDate: '',
    },
  },
  PODetails: {
    hasFilterd: false,
    search: cloneDeep(defaultReportsFilter),
    pharmacies: [],
    coveredEntities: [],
    thirdPartyAdmin: {},
    coveredEntity: null,
    pharmacy: null,
    selectedReportType: {},
    selectedDateRange: {},
    startDate: '',
    endDate: '',
    searchTerms: {
      thirdPartyAdminID: '',
      // coveredEntityID: '',
      pharmacyIDs: '',
      reportType: '',
      dateRange: '',
      startDate: '',
      endDate: '',
    },
  },
  drugcatalog: {
    hasFilterd: false,
    search: cloneDeep(defaultDrugcatalogFilter),
    pharmacies: [],
    coveredEntities: [],
    thirdPartyAdmin: {},
    coveredEntity: null,
    pharmacy: null,
    accountcode:[],
    accountnumberData:[],
    selectedDateRange: {},
    startDate: '',
    endDate: '',
    searchTerms: {
      thirdPartyAdminID: '',
      coveredEntityIDs: '',
      accountcode:'',
      pharmacyIDs: '',
      reportType: '',
      dateRange: '',
      startDate: '',
      endDate: '',
      wholesalerID:'',
      ndc:'',
      chainpharmacyID:'',
      Non340BTenantID:null,
     associateTypeID : null

      
    },
  },
  dashboard: {
    hasFilterd: false,
    search: [], 
    thirdPartyAdmin: {},
    dateRange: {},
    coveredEntity: null,
    pharmacy: null,
    searchTerms: {
      thirdPartyAdminID: '',
       thirdPartyAdminID: '',
        coveredEntityID: '',
        pharmacyID: '',
      dateRangeID: 4,
      ceIds: {},
        pharmacyids: {}
    },

  

    },
    rxManager: {
      hasFilterd: false,
      search: cloneDeep(defaultRxManagerFilter),
      thirdPartyAdmin: {},
      coveredEntity: null,
      pharmacy: null,
      searchTerms: {
        thirdPartyAdminID: '',
        coveredEntityID: '',
        pharmacyID: '',
        startDate: '',
        endDate: '',
        showClaimID: '',
        claimTypeId: '',
        orderStatusID: '',
        wholesalerID: '',
        coveredEntityIDs: {},
        pharmacyIds: {}
      },
    },
    configurations: {
      hasFilterd: false,
      search: cloneDeep(defaultConfigurations),
      thirdPartyAdmin: {},
      // coveredEntity: null,
      chainpharmacy: null,
      searchTerms: {
        thirdPartyAdminID: '',
        // coveredEntityID: '',
        chainpharmacyID: '',
        // ceIds: {},
        chainpharmacyids: {}
      },
    }
};

const initialStates = {
  loading: false,
  purchaseOrder: cloneDeep(defaultStates.purchaseOrder),
  Inventory: cloneDeep(defaultStates.Inventory),
  Invoice: cloneDeep(defaultStates.Invoice),
  contracts: cloneDeep(defaultStates.contracts),
  reports: cloneDeep(defaultStates.reports),
  ClaimReports: cloneDeep(defaultStates.ClaimReports),
  ReplenishedClaimReports: cloneDeep(defaultStates.ReplenishedClaimReports),
  NonReplenishedClaimReports: cloneDeep(defaultStates.NonReplenishedClaimReports),
  PODetails: cloneDeep(defaultStates.PODetails),
  dashboard: cloneDeep(defaultStates.dashboard),
  rxManager: cloneDeep(defaultStates.rxManager),
  drugcatalog:cloneDeep(defaultStates.drugcatalog),
  configurations:cloneDeep(defaultStates.configurations),

};

export { initialStates, defaultStates };
